"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNewZapUrlFromQuery = void 0;
const url_utils_1 = require("@zapier/url-utils");
const services_1 = require("@zapier/services");
const __1 = require("./..");
exports.buildNewZapUrlFromQuery = ({ referrer, zapTitle, allowEmptySteps = false, headServiceId, headActionId, headActionType, tailServiceId, tailActionId, tailActionType, } = {}) => {
    const BASE_URL = referrer
        ? `/app/editor?referrer=${referrer}&create=true`
        : `/app/editor?create=true`;
    if (!headServiceId && !allowEmptySteps) {
        return BASE_URL;
    }
    return [
        `${BASE_URL}`,
        headServiceId ? `template__0__selected_api=${headServiceId}` : null,
        headActionType ? `template__0__type_of=${headActionType}` : null,
        headActionId ? `template__0__action=${headActionId}` : null,
        tailServiceId ? `template__1__selected_api=${tailServiceId}` : null,
        (tailServiceId || allowEmptySteps) && tailActionType
            ? `template__1__type_of=${tailActionType}`
            : null,
        tailServiceId && tailActionId
            ? `template__1__action=${tailActionId}`
            : null,
        zapTitle ? `template__0__title=${encodeURIComponent(zapTitle)}` : null,
    ]
        .filter(Boolean)
        .join('&');
};
const getHrefForBlankZap = ({ query, referrer, }) => {
    return {
        href: exports.buildNewZapUrlFromQuery(Object.assign(Object.assign({}, (query || {})), { referrer })),
        type: 'blank',
    };
};
const getHrefForZts = (props) => {
    const { zt, referrer, services } = props;
    if (!zt) {
        return getHrefForBlankZap(props);
    }
    const serviceIds = services_1.utils.getServiceIds(services);
    return {
        href: url_utils_1.addParamsToUrl(`/app/editor/template/${zt.id}`, {
            selected_apis: (serviceIds || []).join(','),
            referrer,
        }, true),
        type: 'template',
    };
};
const getHrefFromOutline = (props) => {
    const { query, referrer, services = [] } = props;
    const generateZapTitle = query && query.headServiceName
        ? __1.generateZapTitleFromQuery
        : __1.generateZapTitleFromActions;
    const zapTitle = generateZapTitle({
        query,
        services,
    });
    const flattenedState = Object.assign({ zapTitle,
        referrer }, query);
    return {
        href: exports.buildNewZapUrlFromQuery(flattenedState),
        type: 'outline',
        zapTitle,
    };
};
const buildNewZapUrl = (props) => {
    const { zt, query, referrer } = props;
    const { headAction, tailAction } = __1.convertToHeadAndTailActions(query);
    const queryIsEmpty = query && Object.keys(query).every(key => !query[key]);
    if (!zt && (!query || queryIsEmpty)) {
        return getHrefForBlankZap(props);
    }
    if (zt) {
        return getHrefForZts(props);
    }
    const headActionChosen = headAction && headAction.serviceId && headAction.id;
    const tailActionChosen = tailAction && tailAction.serviceId && tailAction.id;
    if (!(headActionChosen && tailActionChosen)) {
        return {
            href: exports.buildNewZapUrlFromQuery(Object.assign(Object.assign({}, query), { referrer })),
            type: 'partial',
        };
    }
    return getHrefFromOutline(props);
};
exports.default = buildNewZapUrl;
